import React, { useEffect, useState } from "react";
import { paths, coberturasPath } from "~constants/referenceNames";
import { Switch, Route, useLocation, useHistory } from "react-router-dom";
import ListadoCobertura from "~components/views/coberturas/ListadoCoberturas";

const CoberturasRoutes = () => {
  const location = useLocation();
  const history = useHistory();
  const [companiaId, setCompaniaId] = useState<string | null>(null);

  useEffect(() => {
    const defaultPath = `${paths[coberturasPath]}/Sancor`;
    const pathname = location.pathname.split("/");
    if (pathname[2]) {
      setCompaniaId(pathname[2]);
    } else {
      if (location.pathname !== defaultPath) {
        history.replace(defaultPath);
      }
    }
  }, [history, location.pathname]);

  return (
    <Switch>
      <Route path={paths[coberturasPath]}>
        <ListadoCobertura companiaId={companiaId} />
      </Route>
    </Switch>
  );
};

export default CoberturasRoutes;
